<template>
  <div>
    <v-toolbar
      class="text-h6 mx-1 mb-3"
      :class="darkMode ? '' : 'mt-1'"
      style="width: 61.6vw"
      data-testid="promise-header"
    >
      Payment Date
    </v-toolbar>
    <div class="overflow-y-auto pt-2" style="max-height: 510px;">
      <v-date-picker
        data-testid="promise-to-pay-date-picker"
        class="promise-to-pay-date-picker mx-1"
        v-model="selectedDate"
        :min="minDate"
        :max="promiseDateLimit"
        header-color="blue darken-1"
        color="blue darken-1"
        style="border: 1px solid gray"
        full-width
        landscape
        scrollable
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "PromiseDate",

  computed: {
    ...mapState({
      darkMode: state => state.application.settings.darkTheme,
      promiseDate: state => state.accountsReceivable.promiseDate
    }),

    selectedDate: {
      get() {
        return this.promiseDate;
      },
      set(newVal) {
        this.$store.commit("updatePromiseDate", newVal);
      }
    },

    minDate() {
      return new Date().toISOString().substr(0, 10) + 1;
    },

    promiseDateLimit() {
      return moment.utc().endOf("month").format("YYYY-MM-DD");
    }
  }
};
</script>
